import axios from 'axios';
import { API_BASE_URL } from '../config/env';

export const authService = {
  login: async (email, password) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/login`, {
        email,
        password,
      }, {
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: 10000,
      });
      
      return response.data;
    } catch (error) {
      if (error.response) {
        return {
          success: false,
          error: error.response.data?.error || 'Login failed',
        };
      }
      return {
        success: false,
        error: error.message || 'Network error',
      };
    }
  },

  register: async ({ name, email, phone, password }) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/register`, {
        name,
        email,
        phone,
        password,
      }, {
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: 15000,
      });

      return response.data;
    } catch (error) {
      if (error.response) {
        const d = error.response.data || {};
        return {
          success: false,
          error: d.message || d.error || 'Registration failed',
        };
      }
      return {
        success: false,
        error: error.message || 'Network error',
      };
    }
  },
  
  // Validate token (optional - for checking if token is still valid)
  validateToken: async (token, storeId) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/control/store-info`, {
        token,
        store_id: storeId,
      }, {
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: 10000,
      });
      
      return response.data.success;
    } catch {
      return false;
    }
  },
};

